import {Button, ButtonProps, useListContext, useNotify} from "react-admin";
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import {client} from "../../dataProvider";
import {useState} from "react";
import {CircularProgress} from "@material-ui/core";

export const HideOnMapsButton = (props: ButtonProps) => {
  const notify = useNotify();
  const [loading, setLoading] = useState(false);
  const { selectedIds, refetch } = useListContext();
  const handleSubmit = async (e: any) => {
    e.stopPropagation();
    setLoading(true);
    client(`routes/hide_on_maps`, {
      method: "POST",
      data: { ids: selectedIds },
    })
      .then(() => {
        refetch();
        notify("Fatto", "success");
      })
      .catch(() => {
        notify("ra.message.error", "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Button
      {...props}
      disabled={loading || selectedIds.length <= 0}
      label="Nascondi su mappa"
      onClick={handleSubmit}
    >
      {loading ? <CircularProgress size={18} thickness={2} /> : <VisibilityOffIcon />}
    </Button>
  );
};

export const ShowOnMapsButton = (props: ButtonProps) => {
  const notify = useNotify();
  const [loading, setLoading] = useState(false);
  const { selectedIds, refetch } = useListContext();
  const handleSubmit = async (e: any) => {
    e.stopPropagation();
    setLoading(true);
    client(`routes/show_on_maps`, {
      method: "POST",
      data: { ids: selectedIds },
    })
      .then(() => {
        refetch();
        notify("Fatto", "success");
      })
      .catch(() => {
        notify("ra.message.error", "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Button
      {...props}
      disabled={loading || selectedIds.length <= 0}
      label="Mostra su mappa"
      onClick={handleSubmit}
    >
      {loading ? <CircularProgress size={18} thickness={2} /> : <VisibilityIcon />}
    </Button>
  );
};
